// js与app通信

const isExit = (v) => {
  return v != null && typeof v != 'undefined';
}

const isFn = (v) => {
  return typeof v == 'function';
}

class App {
  static isIos() {
    return this.isIphone() || this.isMac();
  }

  static isIphone() {
    const ua = navigator.userAgent.toLowerCase();
    let iosInfo = ua.match(/iPhone OS (\d+)/i) ;
    return !!iosInfo;
  }

  static isMac() {
    const ua = navigator.userAgent.toLowerCase();
    let macInfo = ua.match(/Mac OS X (\d+)/i);
    return !!macInfo;
  }
}

class NativeBridge {
  postMessage(options) {
    let message = options.bridgeName;
    let androidName = options.androidName;
    let parm = options.data;
    let elseFn = !!options.else ? options.else : function() {}; // 如果方法不存在的处理方法

    try {
      if (App.isIos()) {
        if (isExit(window.webkit) == false) {
          console.log("window.webkit不存在");
          elseFn();
          return;
        }

        if (isExit(window.webkit.messageHandlers) == false) {
          console.log("window.webkit.messageHandlers不存在");
          elseFn();
          return;
        }

        if (isExit(window.webkit.messageHandlers[message]) == false) {
          console.log(`window.webkit.messageHandlers[${message}]不存在`);
          elseFn();
          return;
        }

        if (isFn(window.webkit.messageHandlers[message].postMessage) == false) {
          console.log(`window.webkit.messageHandlers[${message}].postMessage is not function`);
          elseFn();
          return;
        }

        window.webkit.messageHandlers[message].postMessage({body: parm});
      } else {
        let adInsetence = this.getAndroidinstence(androidName);

        if (adInsetence == null) {
          console.log("安卓实例不存在");
          elseFn();
          return;
        }

        if (isFn(adInsetence[message]) == false) {
          console.log("安卓方法不存在");
          elseFn();
          return;
        }

        if (parm == null) {
          adInsetence[message]();
        } else {
          adInsetence[message](parm);
        }
      }
    } catch(e) {
      console.log("触发原生事件出错：", e);
    }
  }

  getAndroidinstence(adName = '') {
    let adFn = this.adInsetenceList(adName);
    let androidInstence = null;

    try {
      androidInstence = adFn();
    }catch(e) {
      console.log('获取安卓实例异常：', e);
    }

    return androidInstence;
  }

  adInsetenceList(name) {
    if (name == '') {
      return function(){ return JStInterface; }
    }

    if (name == 'jsToAndroid') {
      return function() { return jsToAndroid; }
    }

    return function(){ return JStInterface; }
  }
}

class WindowRegest {
  constructor() {
    this.regestList = {};
  }

  initRegestBridgeName(bridgeName) {
    if (!this.regestList[bridgeName]) {
      regestList[bridgeName] = [];
    }
  }

  initRegestBridgeFunc(bridgeName) {
    if (!window[bridgeName]) {
      let _this = this;

      window[bridgeName] = function(options){
        for (let func of _this.regestList[bridgeName]) {
          func(options);
        }
      }
    }
  }

  addRegestBridgeFunc(bridgeName, callback) {
    this.regestList[bridgeName].push(callback);
  }

  regest(options) {
    this.initRegestBridgeName(options.bridgeName);
    this.initRegestBridgeFunc();
    this.addRegestBridgeFunc(options.bridgeName, options.callback);
  }

}

class Bridge {
  constructor() {
    this.nativeBridge = new NativeBridge();
    this.windowRegest = new WindowRegest();
    this.app = App;
  }

  invoke(options) {
    this.nativeBridge.postMessage({
        bridgeName: options.bridgeName,
        data: options.data,
        else: options.else,
        androidName: options.androidName
    });
  }

  regest(options) {
    this.windowRegest({
      bridgeName: options.bridgeName,
      callback: options.callback
    });
  }

  static getInstance() {
    let instance = null;

　　 return function(){
　　　 if ( !instance ){
　　　　　instance = new Bridge();
　　　 }

　　　 return instance;　　　　　　　　　　
　　}
  }
}

const JsBridge = Bridge.getInstance()();

export default JsBridge;
